import * as THREE from 'three';
export class HeartCurve extends THREE.Curve {
    constructor(scale = 1, z = 0) {
        super();
        this.scale = scale;
        this.z = z;
    }
    getPoint(t, target = new THREE.Vector3()) {
        const a = t * Math.PI * 2;
        const x = 12 * Math.pow(Math.sin(a), 3);
        const y = 13 * Math.cos(a)
            - 5 * Math.cos(2 * a)
            - 2 * Math.cos(3 * a)
            - Math.cos(4 * a);
        target.set(x * this.scale, y * this.scale, this.z);
        return target;
    }
}
export class SoftHeartCurve extends THREE.Curve {
    constructor(scale = 10, z = 0) {
        super();
        this.scale = scale;
        this.z = z;
    }
    getPoint(t, target = new THREE.Vector3()) {
        const a = t * Math.PI * 2;
        const x = Math.sin(a);
        const y = Math.cos(a) - 0.6 * Math.cos(2 * a);
        target.set(x * this.scale, y * this.scale, this.z);
        return target;
    }
}
